import {ComponentProps} from "react";

import {InputField} from "@pg-design/rhf-components-module";

import {useEmailInputVerification} from "../hooks/use_email_input_verification";
import {EmailVerificationResponse} from "../types/EmailVerificationResponse";

interface Props extends Omit<ComponentProps<typeof InputField>, "name"> {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    dataTestId?: string;
}

// Email input component with bouncer validation support for react hook form usage.
// Verification runs on debounced value changes (typing, paste, autocomplete) and is flushed on blur.
export const EmailInputWithVerification = (props: Props) => {
    const {verificationData, verificationTrigger, dataTestId, className, disabled, onBlur, onPaste, autoComplete, ...rest} = props;

    const {handleBlur, handlePaste, inputRef} = useEmailInputVerification({
        verificationData,
        verificationTrigger,
        disabled,
        onBlur,
        onPaste
    });

    return (
        <InputField
            ref={inputRef}
            name="email"
            autoComplete={autoComplete ?? "email"}
            placeholder="E-mail"
            onBlur={handleBlur}
            onPaste={handlePaste}
            dataTestId={dataTestId}
            className={className}
            disabled={disabled}
            {...rest}
        />
    );
};
import {ComponentProps} from "react";

import {InputField} from "@pg-design/rhf-components-module";

import {useEmailInputVerification} from "../hooks/use_email_input_verification";
import {EmailVerificationResponse} from "../types/EmailVerificationResponse";

interface Props extends Omit<ComponentProps<typeof InputField>, "name"> {
    verificationData: EmailVerificationResponse | undefined;
    verificationTrigger: (email: string | null) => void;
    dataTestId?: string;
}

// Email input component with bouncer validation support for react hook form usage.
// Verification runs on debounced value changes (typing, paste, autocomplete) and is flushed on blur.
export const EmailInputWithVerification = (props: Props) => {
    const {verificationData, verificationTrigger, dataTestId, className, disabled, onBlur, onPaste, autoComplete, ...rest} = props;

    const {handleBlur, handlePaste, inputRef} = useEmailInputVerification({
        verificationData,
        verificationTrigger,
        disabled,
        onBlur,
        onPaste
    });

    return (
        <InputField
            ref={inputRef}
            name="email"
            autoComplete={autoComplete ?? "email"}
            placeholder="E-mail"
            onBlur={handleBlur}
            onPaste={handlePaste}
            dataTestId={dataTestId}
            className={className}
            disabled={disabled}
            {...rest}
        />
    );
};
